import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "react-bootstrap";
// import avatar from "../../assets/images/user.png";
import { FaPen, FaSearch } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import WebService from "../../utility/WebService";
import ChangePasswordBlade from "./ChangePassword";
import { ArrowLeft } from "react-bootstrap-icons";
export interface AdminUserInterface {
  _id: number;
  fullName: string;
  email: string;
  username: string;
  password: string;
  user_type: "ADMIN" | "USER";
  organization?: string;
  otp?: string | null;
  phone?: string | null;
  temp_otp?: string | null;
  type?: string | null;
  isVerified: string; // 'Y' or 'N'
  verificationToken?: string;
  social_type?: string | null;
  socialid?: string | null;
  confirmPassword?: string;
}
const Profile = () => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState<any>({});
  const [showModal, setShowModal] = useState(false);
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [selectedUser, setSelectedUser] = useState<AdminUserInterface | null>(
    null
  );
  const [passwordBladeOpen, setPasswordBladeOpen] = useState(false);

  useEffect(() => {
    getUserData();
    //  roleList();
  }, []);
  useEffect(() => {
    if (userData && roles.length > 0) {
      setValue("role_id", userData.role_id);
    }
  }, [roles, userData]);
  const roleList = () => {
    setLoading(true);
    WebService.getAPI({
      action: `/admin-roles`,
      body: null,
    })
      .then((res: any) => {
        console.log("roles", res);
        setLoading(false);
        setRoles(res.list);
      })
      .catch((e: any) => {
        setLoading(false);
        toast.error(e?.response?.data?.message);
      });
  };
  const getUserData = () => {
    // setLoading(true);
    WebService.getAPI({
      action: `users/me`,
      body: null,
    })
      .then((res: any) => {
        console.log("User Data Response:", res.data);
        setLoading(false);
        setUserData(res.data);
        setValue("fullName", res.data.fullName);
        setValue("username", res.data.username);
        setValue("email", res.data.email);
        setValue("phone", res.data.phone);
        //  console.log(res.result.role.name);
      })
      .catch((e) => {
        setLoading(false);
        toast.error("Failed to fetch user data.");
      });
  };
  const onSave = (data: any) => {
    // var uuid = userData.uuid;
    var obj = {
      fullName: data.fullName,
      email: data.email,
      phone: data.phone,
      username: data.username,
      //   role_id: data.role_id,
    };
    setLoading(true);
    WebService.postAPI({
      action: `users/update-user-profile`,
      body: obj,
    })
      .then((res: any) => {
        toast.success(res.message);
        console.log("res in profile......", res);

        setLoading(false);
        // ✅ GO BACK AFTER SUBMIT
        navigate(-1);
        // getUserData();
      })
      .catch((e) => {
        console.log(e);
        toast.error(e.message);
        setLoading(false);
      });
  };
  const openPasswordBlade = () => {
    setPasswordBladeOpen(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="events-main">
    <Container className="d-flex flex-column align-items-center py-4">
      {/* Profile Card */}
      <Card
        className="p-4 shadow-sm"
        style={{ maxWidth: "800px", width: "100%" }}
      >
        <div className="d-flex align-items-center mb-4">
          {/* <ArrowLeft
            size={22}
            className="me-3 cursor-pointer"
            onClick={() => window.history.back()}
          /> */}
          <h2 className="mb-0">User Profile</h2>
        </div>
        {/* Form Inputs */}
        <Form onSubmit={handleSubmit(onSave)}>
          <Form.Group className="mb-3">
            <Form.Label className="">
              Full Name<span className="error">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter full name"
              {...register("fullName", { required: true })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="">
              User Name<span className="error">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter user name"
              {...register("username", { required: false })}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="">
              Email ID<span className="error">*</span>
            </Form.Label>
            <Row>
              <Col sm={12}>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  {...register("email", { required: true })}
                  disabled
                />

                <div className="text-end mt-1">
                  <a
                    href="#"
                    className="text-decoration-underline"
                    style={{ whiteSpace: "nowrap", fontSize: "0.85rem" }}
                    onClick={(e) => {
                      e.preventDefault();
                      openPasswordBlade();
                    }}
                  >
                    Change Password
                  </a>
                </div>
              </Col>
              {/* <Form.Group className="mb-3">
                <Form.Label className="">Contact</Form.Label>
                <Form.Control
                  type="text"
                  maxLength={10}
                  placeholder="Enter phone"
                  {...register("phone", { required: false })}
                />
              </Form.Group> */}
              {/* <Col lg={4}>
                <Button
                  onClick={handleChangeEmail}
                  variant="outline-dark"
                  className="w-100 font-14"
                >
                  Change Email
                </Button>
              </Col> */}
            </Row>
            {/* <Row className="mb-3">
              <Col md={12}>
                <Form.Group controlId="role">
                  <Form.Label>Role</Form.Label>
                  <Form.Select
                    {...register("role_id", { required: false })}
                    disabled
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {roles.map((role: any) => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row> */}
          </Form.Group>
          <div className="d-flex gap-2 justify-content-end">
            <Button
              variant="secondary"
              type="button"
              onClick={() => navigate(-1)}   // 🔥 go back
            >
              Cancel
            </Button>

            <Button type="submit" className="btn btn-brand-1">
              Submit
            </Button>
          </div>

          {/* <Form.Group className="mb-3">
            <Form.Label className="">Password</Form.Label>
            <Row>
              <Col sm={7}>
                <Form.Control type="password" />
              </Col>
              <Col sm={5}>
                <Button variant="outline-dark" className="w-100 font-14">
                  Change Password
                </Button>
              </Col>
            </Row>
          </Form.Group> */}
        </Form>
        <hr></hr>
      </Card>
      <ChangePasswordBlade
        isShow={passwordBladeOpen}
        isClose={() => setPasswordBladeOpen(false)}
      />




      {/* Footer Links */}
    </Container>
    </div>
  );
};

export default Profile;
